module.exports = __webpack_public_path__ + "img/数字孪生.46945b52.svg";